// BUILD-042 — HR Administration secondary rail (Owner decision 2026-10-24).
// A compact, always-visible list of five destinations under the title "HR Administration": Employees, Company setup, Access permissions,
// Activity log, Correction requests. No nested menu and no accordion: the old three-group accordion with a long "HR setup" list overflowed
// and hid destinations. Company setup is a landing page over the former HR-setup destinations (see CompanySetupPanel.tsx) and stays highlighted
// on any of its child routes. Each item is a REAL route (NavLink), so every deep link keeps working. The narrow-screen collapse is done by the
// shared HrWorkspaceFrame (a "Menu" disclosure), not here. Plain Link (not NavLink): NavLink would overwrite aria-current with its own "is this exact URL" answer,
// and Company setup must read as current on all of its child routes.
import { Link } from 'react-router-dom';
import { ADMIN_RAIL_ITEMS, type AdminNavKey } from './adminNavGroups';

export function AdminNav({ active }: { active: AdminNavKey }) {
  return (
    <nav aria-label="HR administration sections" className="bg-white rounded-lg border border-gray-200 shadow-sm p-2" data-testid="admin-rail">
      <div className="px-2.5 pt-1.5 pb-2 text-sm font-bold text-gray-900">HR Administration</div>
      <ul className="space-y-0.5">
        {ADMIN_RAIL_ITEMS.map((item) => {
          const selected = item.key === active;
          return (
            <li key={item.key}>
              <Link
                to={item.path}
                data-testid={`admin-rail-${item.key}`}
                className={`block px-2.5 py-2 rounded-md text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4AABDE] ${
                  selected ? 'bg-[#EDF5FC] text-[#176A9B] font-medium' : 'text-gray-600 hover:bg-gray-50'
                }`}
                aria-current={selected ? 'page' : undefined}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
